/**
 * @file   src\mobile\components\Home\Search.js
 * @brief  This file is responsible for select property
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";
import SearchImg from "../../images/search-icn.svg";
import BuildingIcon from "../../images/citybuildingsIcn.svg";
import LocationIcon from "../../images/locationIcn.svg";
import SearchImgWhite from "../../images/search-icn-white.svg";
import BuildingIconWhite from "../../images/citybuildingsIcn-white.svg";
import LocationIconWhite from "../../images/locationIcn-white.svg";
import { getLocalStorage, sortItems } from "../../../helpers/common";
import { RECENT_SEARCHES, USER_LOCATION_KEY } from "../../../constants/common";
import { usePremium } from "@/hooks";

const Search = (props) => {
  const { handleSelection, location, locationList, handleResentSelect } = props;

  const recentSearches = getLocalStorage(RECENT_SEARCHES);
  const browserLocation = getLocalStorage(USER_LOCATION_KEY);

  const { shouldToggleColor } = usePremium();

  const _searchImg = shouldToggleColor ? SearchImgWhite : SearchImg;
  const _buildingImg = shouldToggleColor ? BuildingIconWhite : BuildingIcon;
  const _locationImg = shouldToggleColor ? LocationIconWhite : LocationIcon;

  return (
    <>
      <div
        className={`search_wrap_mobile_dpmenu ${shouldToggleColor ? "search_wrap_mobile_dpmenu_premium" : ""}`}
      >
        {browserLocation != null ? (
          <div
            className="d-flex current-location-info align-items-center pb-3"
            style={{ cursor: "pointer" }}
            onClick={() => handleSelection({ section: "currentLoc" })}
            onKeyDown={() => handleSelection({ section: "currentLoc" })}
            role="button"
          >
            <img src={_locationImg} alt="" />
            <span
              className={`ps-1 ${shouldToggleColor ? "location-paragraph-premium" : ""}`}
            >
              {" "}
              Use Current Location
            </span>
          </div>
        ) : (
          <></>
        )}
        {recentSearches?.length > 0 && (
          <div className="pb-3">
            <div
              className={`fnt12 txtCaps text-capitalize recent-search-txt ${shouldToggleColor ? "recent-search-txt-premium" : ""} `}
            >
              Recent Searches
            </div>

            <ul className="searchResultListing">
              {recentSearches.sort(sortItems("desc", "index")).map((rs, i) => {
                const searchKey = _.get(rs, "key", null);
                const section = _.get(rs, "section", null);
                const isKeyWordSearch = section === "keyword";

                return (
                  <li
                    key={i}
                    onClick={(e) => {
                      handleResentSelect(rs);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src={isKeyWordSearch ? _searchImg : _buildingImg}
                      alt=""
                    />{" "}
                    <span
                      className={`ps-1 ${shouldToggleColor ? "location-paragraph-premium" : ""}`}
                    >
                      {" "}
                      {searchKey}
                    </span>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
        {location && (
          <div
            className="pb-3"
            style={{ cursor: "pointer" }}
            onClick={() => handleSelection({ section: "keyword" })}
            onKeyDown={() => handleSelection({ section: "keyword" })}
            role="button"
          >
            <div
              className={`keyword-search-txt ${shouldToggleColor ? "keyword-search-txt-premium" : ""}`}
            >
              keyword
            </div>

            <ul className="searchResultListing">
              <li>
                {" "}
                <img src={_searchImg} alt="" />{" "}
                <span
                  className={`ps-1 ${shouldToggleColor ? "location-paragraph-premium" : ""}`}
                >
                  {" "}
                  "{location}"
                </span>
              </li>
            </ul>
          </div>
        )}

        {location && locationList.length > 0 && (
          <div className="pb-0">
            <div
              className={`keyword-search-txt ${shouldToggleColor ? "keyword-search-txt-premium" : ""}`}
            >
              city
            </div>

            <ul className="searchResultListing">
              {locationList?.map((address, i) => {
                return (
                  <li
                    key={i}
                    onClick={(e) => {
                      handleSelection({
                        section: "locSearch",
                        selectedLoc: address,
                      });
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <img src={_buildingImg} alt="" />{" "}
                    <span
                      className={`ps-1 ${shouldToggleColor ? "location-paragraph-premium" : ""}`}
                    >
                      {" "}
                      {_.get(address, "formatted_address", "")}
                    </span>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </div>
    </>
  );
};

export default Search;
